import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'date-picker-formly',
  templateUrl: './date-picker-formly.component.html',
  styleUrls: ['./date-picker-formly.component.scss'],
})
export class DatePickerFormlyComponent extends FieldType {}
